const regionRelatedfull = new Swiper('.region-related-swiper-full', {
    effect: 'slide',
    loop: false,
    slidesPerView: 4,
    spaceBetween: 30,
    grabCursor: true,
    navigation: {
      nextEl: '.news-next',
      prevEl: '.news-prev',
    },
    breakpoints: {
        300: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: true,
        },
        520: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            loop: true,
        },
        767: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            enabled: true,
            loop: true,
            spaceBetween: 20,
        },
        1180: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            enabled: true,
        }
    },
});

const regionRelated4 = new Swiper('.region-related-swiper-4', {
    effect: 'slide',
    loop: false,
    slidesPerView: 4,
    spaceBetween: 30,
    grabCursor: true,
    navigation: {
      nextEl: '.news-next',
      prevEl: '.news-prev',
    },
    breakpoints: {
        300: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: true,
        },
        520: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            loop: true,
        },
        767: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            enabled: true,
            loop: true,
            spaceBetween: 20,
        },
        1180: {
            slidesPerView: 4,
            slidesPerGroup: 1,
            enabled: false,
        }
    },
});

const regionRelated3 = new Swiper('.region-related-swiper-3', {
    effect: 'slide',
    loop: false,
    slidesPerView: 3,
    spaceBetween: 30,
    grabCursor: true,
    navigation: {
      nextEl: '.news-next',
      prevEl: '.news-prev',
    },
    breakpoints: {
        300: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: true,
        },
        520: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            loop: true,
        },
        767: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            enabled: true,
            loop: true,
            spaceBetween: 20,
        },
        1180: {
            slidesPerView: 3,
            slidesPerGroup: 1,
            enabled: false,
        }
    },
});

const regionRelated2 = new Swiper('.region-related-swiper-2', {
    effect: 'slide',
    loop: false,
    slidesPerView: 2,
    spaceBetween: 30,
    grabCursor: true,
    navigation: {
      nextEl: '.news-next',
      prevEl: '.news-prev',
    },
    breakpoints: {
        300: {
            slidesPerView: 1,
            slidesPerGroup: 1,
            loop: true,
        },
        520: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            loop: true,
        },
        767: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            enabled: true,
            loop: true,
            spaceBetween: 20,
        },
        1180: {
            slidesPerView: 2,
            slidesPerGroup: 1,
            enabled: false,
        }
    },
});